import PersonSideSheet from "@/features/person/components/PersonSideSheet";
import { BackofficePerson } from "@/types";

interface ApplicantDetailsDialogProps {
  applicant: BackofficePerson | null;
  applicationEmail?: string;
  applicationPhone?: string;
  onClose: () => void;
  open: boolean;
}

export default function ApplicantDetailsDialog({
  applicant,
  applicationEmail,
  applicationPhone,
  onClose,
  open
}: ApplicantDetailsDialogProps) {
  return (
    <PersonSideSheet
      open={open}
      onClose={onClose}
      pgaId={applicant?.pgaId ?? null}
      title="Person Details"
      showDefaultSections={true}
      showJobApplications={true}
      showEmployment={true}
      showFacility={true}
      alternateEmail={applicationEmail}
      alternatePhone={applicationPhone}
    />
  );
}
